import React, { memo } from "react";
import {
  Stack,
  Card,
  Box,
  Typography,
  InputBase,
  CardContent,
  Divider,
  Icon,
  IconButton,
} from "investira.react.components";

import { PageTemplate } from "../../components/templates";
const Seguranca = memo(() => {
  return (
    // TODO: Implementar um container responsivo
    <Stack sx={{ width: "70%", margin: "0 auto" }}>
      <PageTemplate title="Segurança">
        <Box component="form" noValidate>
          <Stack spacing={3}>
            <Stack>
              <Card>
                <CardContent>
                  <Typography variant="h6" color="textPrimary" gutterBottom>
                    Acesso
                  </Typography>

                  <Stack direction="row" spacing={3} alignItems="center" mt={3}>
                    <Stack sx={{ width: "200px" }}>
                      <Typography variant="caption" color="textPrimary">
                        Senha
                      </Typography>
                    </Stack>
                    <Stack flexGrow={1}>
                      <InputBase
                        id="password"
                        name="password"
                        type="password"
                        placeholder="********"
                      />
                    </Stack>
                    <Stack>
                      <IconButton color="primary">
                        <Icon iconName="eye" size={24} />
                      </IconButton>
                    </Stack>
                  </Stack>
                  <Divider />

                  <Typography variant="caption" color="textSecondary">
                    Última alteração: 30 dezembro de 2022
                  </Typography>
                </CardContent>
              </Card>
            </Stack>
          </Stack>
        </Box>
      </PageTemplate>
    </Stack>
  );
});

export default Seguranca;
